import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Plus, BookOpen } from "lucide-react";
import { EmptyState, LoadingState, ErrorState } from "@tabipla/ui";
import { MekkeLayout } from "../layouts/MekkeLayout";
import { useBooklets } from "../../application/hooks/useBooklets";
import { BookletCard } from "../components/booklets/BookletCard";

export function BookletsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: booklets, isLoading, error, refetch } = useBooklets();

  if (isLoading) {
    return (
      <MekkeLayout title={t("booklets.title")}>
        <LoadingState message={t("common.loading")} />
      </MekkeLayout>
    );
  }

  if (error) {
    return (
      <MekkeLayout title={t("booklets.title")}>
        <ErrorState
          error={error}
          onRetry={refetch}
          title={t("common.error")}
          retryLabel={t("common.retry")}
        />
      </MekkeLayout>
    );
  }

  return (
    <MekkeLayout
      title={t("booklets.title")}
      fabAction={{
        icon: Plus,
        label: t("booklets.create"),
        onClick: () => navigate("/booklets/new"),
      }}
    >
      <div className="animate-fade-in space-y-6">
        {/* Header Section */}
        <section>
          <h1 className="text-2xl font-bold">{t("booklets.title")}</h1>
          <p className="mt-1 text-muted-foreground">{t("booklets.createFirst")}</p>
        </section>

        {/* Booklets Section */}
        <section className="space-y-4">
          {!booklets || booklets.length === 0 ? (
            <EmptyState
              icon={BookOpen}
              title={t("booklets.empty")}
              description={t("booklets.createFirst")}
              action={{
                label: t("booklets.create"),
                onClick: () => navigate("/booklets/new"),
                icon: Plus,
              }}
              variant="dashed"
            />
          ) : (
            <div className="grid gap-4 sm:grid-cols-2">
              {booklets.map((booklet) => (
                <BookletCard key={booklet.id} booklet={booklet} />
              ))}
            </div>
          )}
        </section>
      </div>
    </MekkeLayout>
  );
}
